import apiClient from "~/services/ApiService"
import { getv4LocaleFromI18nLocale } from "~/scripts/useful-functions"
import { type ApiResource, createUrl } from "~/scripts/api-resource"
import type { AxiosInstance } from "axios"
import type { RuntimeConfig } from "#app"

export class ItemService {
  private axios: AxiosInstance
  private config: RuntimeConfig

  constructor(axios: AxiosInstance, config: RuntimeConfig) {
    this.axios = axios
    this.config = config
  }

  async searchItems(query: any, locale: string): Promise<any> {
    const itemSearch = createUrl(this.config.v4Host + "/ng/item-search", query)
    let response

    try {
      response = await this.axios.get(
        itemSearch,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
    } catch (e) {
      console.log("There was an error", e)
    }

    return response
  }

  async getFurnitureDefaultInventory(query: any, locale: string): Promise<any> {
    const furnitureDefaults = createUrl(this.config.v4Host + "/ng/inventory/furniture-defaults", query)
    let response, items

    try {
      response = await this.axios.get(
        furnitureDefaults,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.items) {
        items = response.data.items
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return items
  }
}
